// graph.js
export async function callMsGraph(accessToken: any, endpoint: any) {
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${accessToken}`);

    const options = {
        method: "GET",
        headers: headers
    };

    const response = await fetch(`https://graph.microsoft.com/v1.0${endpoint}`, options);
    const data = await response.json();
    return data;
}
